import { render } from "./CreateVpnCustomerGateway.vue?vue&type=template&id=2f8db851&scoped=true"
import script from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js"
export * from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js"

import "./CreateVpnCustomerGateway.vue?vue&type=style&index=0&id=2f8db851&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8db851"]])

export default __exports__